/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";

export default class CollectionInfo extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            specimenTypes: [],
            example: {
                specimenID: '1234567890'
            }
        }
    }

    componentDidMount() {
        this.fillList('/api/specimentype/list', 'specimenTypes');
    }

    change = (v) => {
        this.props.onChange?.();
    }

    render() {
        return <Card title="Collection">
            <div className="row">
                <div className="col-md-2">
                    <FormInput model={this.props.item} name="specimenTypeID" label="Specimen Type" type="select" options={this.state.specimenTypes} onChange={this.change} />
                </div>
                <div className="col-md-2">
                    <FormInput model={this.props.item} name="isCollected" label="Collected" type="switch" onChange={this.change} />
                    <small className="form-text text-muted"><L>Check if specimen has been collected</L></small>
                </div>
                {this.props.item.isCollected && <>
                    <div className="col-md-2">
                        <FormInput model={this.props.item} name="collectedDateStr" label="Collection Date" type="date" onChange={this.change} />
                    </div>
                    <div className="col-md-2">
                        <FormInput model={this.props.item} name="collectedTime" label="Collection Time" type="time" onChange={this.change} />
                    </div>
                    <div className="col-md-2">
                        <FormInput model={this.props.item} name="specimenID" label="Specimen Barcode" onChange={this.change} placeholder={this.state.example.specimenID} />
                    </div>
                </>}
            </div>
        </Card>;
    }
}